import { AnyAction } from 'redux';
import { AxiosPromise, AxiosResponse } from 'axios';
import { Operation, ServerResponse } from 'data/types';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'data/root.reducers';

export const API_PATH_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION = '/targettemplate';

export const SET_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_LOADING = 'SET_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_LOADING';

export const GO_TO_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_LIST = 'GO_TO_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_LIST';
export const GO_TO_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_CREATE = 'GO_TO_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_CREATE';
export const GO_TO_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_EDIT = 'GO_TO_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_EDIT';
export const GO_TO_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_VIEW = 'GO_TO_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_VIEW';

export const SELECT_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION = 'SELECT_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION';

export const GET_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION = 'GET_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION';
export const GET_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_PENDING = 'GET_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_PENDING';
export const GET_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_FULFILLED = 'GET_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_FULFILLED';

export const GET_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_LIST = 'GET_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_LIST';
export const GET_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_LIST_PENDING = 'GET_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_LIST_PENDING';
export const GET_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_LIST_FULFILLED = 'GET_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_LIST_FULFILLED';

export const CREATE_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION = 'CREATE_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION';
export const CREATE_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_PENDING = 'CREATE_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_PENDING';
export const CREATE_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_FULFILLED = 'CREATE_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_FULFILLED';
export const CREATE_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_REJECTED = 'CREATE_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_REJECTED';

export const UPDATE_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION = 'UPDATE_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION';
export const UPDATE_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_FULFILLED = 'UPDATE_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_FULFILLED';
export const UPDATE_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_REJECTED = 'UPDATE_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_REJECTED';

export const DELETE_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION = 'DELETE_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION';
export const DELETE_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_FULFILLED = 'DELETE_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_FULFILLED';
export const DELETE_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_REJECTED = 'DELETE_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_REJECTED';

export const TARGET_DELIVERY_TEMPLATE_TEMPORARY_ID = 'targetDeliveryTemplateInterface';

// TODO: must confirm based on XMS
export enum TargetDeliveryTemplateAccessFunctionPrivileges {
  View = 'dc_access',
  Edit = 'dc_access',
  Delete = 'dc_access',
}

export enum TargetDeliveryTemplateAccessFunctionMenuActionsType {
  Delete = 'delete',
  Edit = 'edit',
  View = 'view'
}

export interface TargetDeliveryTemplateAccessFunctionInterface {
  id: string
  name?: string
  options: {
    key: string
    value: string | boolean
  }[]
  operation?: Operation
}

export type TargetDeliveryTemplateSection = {
  id?: string,
  name: string,
  options: { key:string, value: string | boolean | undefined }[]
}

export interface TargetDeliveryTemplateAccessFunction {
  id?: string
  name: string
  afType: string
  afId: string
  afName?: string
  templateSections?: TargetDeliveryTemplateSection[]
  targetInformation?: TargetDeliveryTemplateAccessFunctionInterface[]
  callContentChannels?: TargetDeliveryTemplateAccessFunctionInterface[]
  monitoringCenterFlags?: TargetDeliveryTemplateAccessFunctionInterface[]
  ICD?: TargetDeliveryTemplateAccessFunctionInterface[]
  networkType?: TargetDeliveryTemplateAccessFunctionInterface[]
  callContentType?: TargetDeliveryTemplateAccessFunctionInterface[]
  monitoringCenterNumberInformation?: TargetDeliveryTemplateAccessFunctionInterface[]
  usnbdTargetInformation?: TargetDeliveryTemplateAccessFunctionInterface[]
  usnbdCallContentChannelInformation?: TargetDeliveryTemplateAccessFunctionInterface[]
  operation?: Operation
}

export interface TargetDeliveryTemplateInterfaceFormData extends Omit<TargetDeliveryTemplateAccessFunctionInterface, 'options'>{
  groupId?: string;
  liid?: string;
  targetAccessType?: string;
  cdrIncludesDN?: boolean;
  ccDeliveryInMo?: boolean;
  enablePNI?: boolean;
  ACC?: string;
  connectedLinePresentation?: boolean;
  suppressInterceptNumber?: boolean;
  separateCallContentChannel?: boolean;
  LEA?: string;
  FILEREF?: string;
  CLASS?: string;
  IMS?: boolean;
  POC?: boolean;
  NGN?: boolean;
  VOIP?: boolean;
  DATA?: boolean;
  IA?: boolean;
  MM?: boolean;
  CCCDATAID?: string;
  CCCIAID?: string;
  CCCMMID?: string;
  IRIID?: string;
  IRIMMID?: string;
  IRIPOID?: string;
  assoc?: string;
  definition?: string;
}

export interface TargetDeliveryTemplateAccessFunctionFormData extends Omit<TargetDeliveryTemplateAccessFunction, 'targetInformation' | 'callContentChannels' | 'networkType' | 'callContentType' | 'monitoringCenterFlags' | 'ICD' | 'monitoringCenterNumberInformation' | 'EIMSTARGET' | 'EIMSGENERAL' | 'EIMSWRLNTRGT' | 'usnbdTargetInformation' | 'usnbdCallContentChannelInformation'> {
  main?: TargetDeliveryTemplateInterfaceFormData[],
  targetInformation?: TargetDeliveryTemplateInterfaceFormData[],
  callContentChannels?: TargetDeliveryTemplateInterfaceFormData[],
  callContentType?: TargetDeliveryTemplateInterfaceFormData[],
  ICD?: TargetDeliveryTemplateInterfaceFormData[],
  monitoringCenterFlags?: TargetDeliveryTemplateInterfaceFormData[],
  networkType?: TargetDeliveryTemplateInterfaceFormData[],
  monitoringCenterNumberInformation?: TargetDeliveryTemplateInterfaceFormData[],
  EIMSTARGET?: TargetDeliveryTemplateInterfaceFormData[],
  EIMSMCNB?: TargetDeliveryTemplateInterfaceFormData[],
  EIMSGPRSTRGT?: TargetDeliveryTemplateInterfaceFormData[],
  EIMSMSCTRGT?: TargetDeliveryTemplateInterfaceFormData[],
  EIMSGENERAL?: TargetDeliveryTemplateInterfaceFormData[]
  EIMSWRLNTRGT?: TargetDeliveryTemplateInterfaceFormData[]
  EIMSMC?: TargetDeliveryTemplateInterfaceFormData[]
  usnbdTargetInformation?: TargetDeliveryTemplateInterfaceFormData[]
  usnbdCallContentChannelInformation?: TargetDeliveryTemplateInterfaceFormData[]
}

export interface TargetDeliveryTemplateAccessFunctionRowData {
  id?: string
  name: string
  afType: string
  afId: string
  afName?: string
}

export interface TargetDeliveryTemplateAccessFunctionUIState {
  isCreatePopupOpen: boolean
  isLoading: boolean
}

export interface TargetDeliveryTemplateAccessFunctionState {
  entities: TargetDeliveryTemplateAccessFunction[],
  selected: TargetDeliveryTemplateAccessFunction[],
  single: TargetDeliveryTemplateAccessFunction | null,
  createdId: string | null,
  ui: TargetDeliveryTemplateAccessFunctionUIState,
  targetDeliveryTemplatesMap: Partial<{ [key:string]: TargetDeliveryTemplateAccessFunction }>
}

export interface GoToTargetDeliveryTemplateAccessFunctionListAction extends AnyAction {
  type: typeof GO_TO_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_LIST
}

export interface SetTargetDeliveryTemplateAccessFunctionLoadingAction extends AnyAction {
  type: typeof SET_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_LOADING
  payload: { isLoading: boolean }
}

export interface GetTargetDeliveryTemplateAccessFunctionListAction extends AnyAction {
  type: typeof GET_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_LIST
  payload: AxiosPromise<ServerResponse<TargetDeliveryTemplateAccessFunction>>
}

export interface GetTargetDeliveryTemplateAccessFunctionListPendingAction extends AnyAction {
  type: typeof GET_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_LIST_PENDING
  payload: null
}

export interface GetTargetDeliveryTemplateAccessFunctionListFulfilledAction extends AnyAction {
  type: typeof GET_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_LIST_FULFILLED
  payload: AxiosResponse<ServerResponse<TargetDeliveryTemplateAccessFunction>>
}

export interface GetTargetDeliveryTemplateAccessFunctionAction extends AnyAction {
  type: typeof GET_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION
  payload: AxiosPromise<ServerResponse<TargetDeliveryTemplateAccessFunction>>
}

export interface GetTargetDeliveryTemplateAccessFunctionPendingAction extends AnyAction {
  type: typeof GET_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_PENDING
  payload: null
}

export interface GetTargetDeliveryTemplateAccessFunctionFulfilledAction extends AnyAction {
  type: typeof GET_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_FULFILLED
  payload: AxiosResponse<ServerResponse<TargetDeliveryTemplateAccessFunction>>
}

export interface CreateTargetDeliveryTemplateAccessFunctionThunkAction
  extends ThunkAction<void, RootState, void, AnyAction> {}

export interface CreateTargetDeliveryTemplateAccessFunctionAction extends AnyAction {
  type: typeof CREATE_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION
  payload: AxiosPromise<ServerResponse<TargetDeliveryTemplateAccessFunction>>
}

export interface CreateTargetDeliveryTemplateAccessFunctionPendingAction extends AnyAction {
  type: typeof CREATE_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_PENDING
  payload: null
}

export interface CreateTargetDeliveryTemplateAccessFunctionFulfilledAction extends AnyAction {
  type: typeof CREATE_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_FULFILLED
  payload: AxiosResponse<ServerResponse<TargetDeliveryTemplateAccessFunction>>
}

export interface CreateTargetDeliveryTemplateAccessFunctionRejectedAction extends AnyAction {
  type: typeof CREATE_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_REJECTED
  payload: AxiosResponse<ServerResponse<TargetDeliveryTemplateAccessFunction>>
}

export interface UpdateTargetDeliveryTemplateAccessFunctionThunkAction
  extends ThunkAction<void, RootState, void, AnyAction> {}

export interface UpdateTargetDeliveryTemplateAccessFunctionAction extends AnyAction {
  type: typeof UPDATE_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION
  payload: AxiosPromise<ServerResponse<TargetDeliveryTemplateAccessFunction>>
}

export interface UpdateTargetDeliveryTemplateAccessFunctionFulfilledAction extends AnyAction {
  type: typeof UPDATE_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_FULFILLED
  payload: AxiosResponse<ServerResponse<TargetDeliveryTemplateAccessFunction>>
}

export interface UpdateTargetDeliveryTemplateAccessFunctionRejectedAction extends AnyAction {
  type: typeof UPDATE_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_REJECTED
  payload: AxiosResponse<ServerResponse<TargetDeliveryTemplateAccessFunction>>
}

export interface DeleteTargetDeliveryTemplateAccessFunctionThunkAction
  extends ThunkAction<void, RootState, void, AnyAction> {}

export interface DeleteTargetDeliveryTemplateAccessFunctionAction extends AnyAction {
  type: typeof DELETE_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION
  payload: AxiosPromise<ServerResponse<TargetDeliveryTemplateAccessFunction>>
}

export interface DeleteTargetDeliveryTemplateAccessFunctionFulfilledAction extends AnyAction {
  type: typeof DELETE_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_FULFILLED
  payload: AxiosResponse<ServerResponse<TargetDeliveryTemplateAccessFunction>>
}

export interface DeleteTargetDeliveryTemplateAccessFunctionRejectedAction extends AnyAction {
  type: typeof DELETE_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_REJECTED
  payload: AxiosResponse<ServerResponse<TargetDeliveryTemplateAccessFunction>>
}

export interface SelectTargetDeliveryTemplateAccessFunctionAction extends AnyAction{
  type: typeof SELECT_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION
  payload: TargetDeliveryTemplateAccessFunction[]
}

export type TargetDeliveryTemplateAccessFunctionActionTypes =
  GoToTargetDeliveryTemplateAccessFunctionListAction |
  SetTargetDeliveryTemplateAccessFunctionLoadingAction |
  GetTargetDeliveryTemplateAccessFunctionListAction |
  GetTargetDeliveryTemplateAccessFunctionListPendingAction |
  GetTargetDeliveryTemplateAccessFunctionListFulfilledAction |
  GetTargetDeliveryTemplateAccessFunctionAction |
  GetTargetDeliveryTemplateAccessFunctionPendingAction |
  GetTargetDeliveryTemplateAccessFunctionFulfilledAction |
  CreateTargetDeliveryTemplateAccessFunctionAction |
  CreateTargetDeliveryTemplateAccessFunctionPendingAction |
  CreateTargetDeliveryTemplateAccessFunctionFulfilledAction |
  CreateTargetDeliveryTemplateAccessFunctionRejectedAction |
  UpdateTargetDeliveryTemplateAccessFunctionAction |
  UpdateTargetDeliveryTemplateAccessFunctionFulfilledAction |
  UpdateTargetDeliveryTemplateAccessFunctionRejectedAction |
  DeleteTargetDeliveryTemplateAccessFunctionAction |
  DeleteTargetDeliveryTemplateAccessFunctionFulfilledAction |
  DeleteTargetDeliveryTemplateAccessFunctionRejectedAction |
  SelectTargetDeliveryTemplateAccessFunctionAction;
